/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BalanceUnitStatementEntryDebit } from './BalanceUnitStatementEntryDebit';
import {
    BalanceUnitStatementEntryDebitFromJSON,
    BalanceUnitStatementEntryDebitFromJSONTyped,
    BalanceUnitStatementEntryDebitToJSON,
    BalanceUnitStatementEntryDebitToJSONTyped,
} from './BalanceUnitStatementEntryDebit';
import type { Gender } from './Gender';
import {
    GenderFromJSON,
    GenderFromJSONTyped,
    GenderToJSON,
    GenderToJSONTyped,
} from './Gender';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface UpdateStudentRequest
 */
export interface UpdateStudentRequest {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof UpdateStudentRequest
     */
    studentId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof UpdateStudentRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateStudentRequest
     */
    lastName: string;
    /**
     * 
     * @type {Gender}
     * @memberof UpdateStudentRequest
     */
    gender: Gender;
    /**
     * 
     * @type {Date}
     * @memberof UpdateStudentRequest
     */
    dateOfBirth: Date;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateStudentRequest
     */
    isActive: boolean;
    /**
     * 
     * @type {Array<ApiUserTasksGetPageParameter>}
     * @memberof UpdateStudentRequest
     */
    locationIds: Array<ApiUserTasksGetPageParameter>;
    /**
     * 
     * @type {string}
     * @memberof UpdateStudentRequest
     */
    medications?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateStudentRequest
     */
    allergies?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateStudentRequest
     */
    specialNeeds?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateStudentRequest
     */
    primaryDoctor?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateStudentRequest
     */
    preferredName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateStudentRequest
     */
    cellPhone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateStudentRequest
     */
    homePhone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateStudentRequest
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateStudentRequest
     */
    address?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateStudentRequest
     */
    postPublicly?: boolean | null;
    /**
     * 
     * @type {any}
     * @memberof UpdateStudentRequest
     */
    startDate?: any | null;
    /**
     * 
     * @type {any}
     * @memberof UpdateStudentRequest
     */
    dropDate?: any | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateStudentRequest
     */
    sendSms?: boolean | null;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof UpdateStudentRequest
     */
    discountPercentage?: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateStudentRequest
     */
    noCharge?: boolean | null;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof UpdateStudentRequest
     */
    tuition?: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateStudentRequest
     */
    recital?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateStudentRequest
     */
    isTuitionOverridden?: boolean | null;
}



/**
 * Check if a given object implements the UpdateStudentRequest interface.
 */
export function instanceOfUpdateStudentRequest(value: object): value is UpdateStudentRequest {
    if (!('studentId' in value) || value['studentId'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('gender' in value) || value['gender'] === undefined) return false;
    if (!('dateOfBirth' in value) || value['dateOfBirth'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('locationIds' in value) || value['locationIds'] === undefined) return false;
    return true;
}

export function UpdateStudentRequestFromJSON(json: any): UpdateStudentRequest {
    return UpdateStudentRequestFromJSONTyped(json, false);
}

export function UpdateStudentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateStudentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'studentId': ApiUserTasksGetPageParameterFromJSON(json['studentId']),
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'gender': GenderFromJSON(json['gender']),
        'dateOfBirth': (new Date(json['dateOfBirth'])),
        'isActive': json['isActive'],
        'locationIds': ((json['locationIds'] as Array<any>).map(ApiUserTasksGetPageParameterFromJSON)),
        'medications': json['medications'] == null ? undefined : json['medications'],
        'allergies': json['allergies'] == null ? undefined : json['allergies'],
        'specialNeeds': json['specialNeeds'] == null ? undefined : json['specialNeeds'],
        'primaryDoctor': json['primaryDoctor'] == null ? undefined : json['primaryDoctor'],
        'preferredName': json['preferredName'] == null ? undefined : json['preferredName'],
        'cellPhone': json['cellPhone'] == null ? undefined : json['cellPhone'],
        'homePhone': json['homePhone'] == null ? undefined : json['homePhone'],
        'email': json['email'] == null ? undefined : json['email'],
        'address': json['address'] == null ? undefined : json['address'],
        'postPublicly': json['postPublicly'] == null ? undefined : json['postPublicly'],
        'startDate': json['startDate'] == null ? undefined : json['startDate'],
        'dropDate': json['dropDate'] == null ? undefined : json['dropDate'],
        'sendSms': json['sendSms'] == null ? undefined : json['sendSms'],
        'discountPercentage': json['discountPercentage'] == null ? undefined : BalanceUnitStatementEntryDebitFromJSON(json['discountPercentage']),
        'noCharge': json['noCharge'] == null ? undefined : json['noCharge'],
        'tuition': json['tuition'] == null ? undefined : BalanceUnitStatementEntryDebitFromJSON(json['tuition']),
        'recital': json['recital'] == null ? undefined : json['recital'],
        'isTuitionOverridden': json['isTuitionOverridden'] == null ? undefined : json['isTuitionOverridden'],
    };
}

export function UpdateStudentRequestToJSON(json: any): UpdateStudentRequest {
    return UpdateStudentRequestToJSONTyped(json, false);
}

export function UpdateStudentRequestToJSONTyped(value?: UpdateStudentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'studentId': ApiUserTasksGetPageParameterToJSON(value['studentId']),
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'gender': GenderToJSON(value['gender']),
        'dateOfBirth': value['dateOfBirth'].toISOString().substring(0,10),
        'isActive': value['isActive'],
        'locationIds': ((value['locationIds'] as Array<any>).map(ApiUserTasksGetPageParameterToJSON)),
        'medications': value['medications'],
        'allergies': value['allergies'],
        'specialNeeds': value['specialNeeds'],
        'primaryDoctor': value['primaryDoctor'],
        'preferredName': value['preferredName'],
        'cellPhone': value['cellPhone'],
        'homePhone': value['homePhone'],
        'email': value['email'],
        'address': value['address'],
        'postPublicly': value['postPublicly'],
        'startDate': value['startDate'],
        'dropDate': value['dropDate'],
        'sendSms': value['sendSms'],
        'discountPercentage': BalanceUnitStatementEntryDebitToJSON(value['discountPercentage']),
        'noCharge': value['noCharge'],
        'tuition': BalanceUnitStatementEntryDebitToJSON(value['tuition']),
        'recital': value['recital'],
        'isTuitionOverridden': value['isTuitionOverridden'],
    };
}

